export const vuepagetext = {
    position : "Position",
    categoryname : "Nom de la catégorie",
    vuescount : "Nombre de vues",
    chartscount : "Nombre de graphiques",
    addcategory : "Ajouter une catégorie",
    editcategory : "Modifier la catégorie",
    delcategory : "Supprimer la catégorie",
    viewname: "Nom de la vue",
    columns: "Colonnes",
    chartname: "Nom du graphique",
    charttype: "Type de graphique",
    chartgranularity: "Granularité"
}